import * as React from 'react'
import Box from '@mui/material/Box'
import Radio from '@mui/material/Radio'
import { useFormikContext } from 'formik'

import { useSplitServices } from './hooks'
import { FormControlLabel } from '../../../atoms'
import { ServiceCheckbox } from './ServiceCheckbox'
import type { LocAndSvcsFormModel } from '../formConfig'
import type { CheckboxOption, CheckedHandler } from '../typings'

type ScheduleServiceProps = {
  onChange: CheckedHandler
  serviceOptions: CheckboxOption[]
}

export function ScheduleService(props: ScheduleServiceProps) {
  const { onChange } = props

  const {
    values: { serviceType },
  } = useFormikContext<LocAndSvcsFormModel>()

  const { oneTime, recurring, hasOneTime, hasRecurring, onChangeRadio } =
    useSplitServices(props)

  const oneTimeDisabled = serviceType !== 'oneTime'
  const recurringDisabled = serviceType !== 'recurring'

  return (
    <>
      {hasRecurring && (
        <>
          <FormControlLabel
            value="recurring"
            name="serviceType"
            control={<Radio />}
            onChange={onChangeRadio}
            label="Schedule Recurring (Service Setup with Initial Service Order)"
            checked={serviceType === 'recurring'}
            data-test-id="recurring-radio-button"
          />
          <Box ml={2} mt={-1}>
            {recurring.map((s) => (
              <ServiceCheckbox
                key={s.id}
                service={s}
                onChange={onChange}
                disabled={recurringDisabled}
              />
            ))}
          </Box>
        </>
      )}

      {hasOneTime && (
        <>
          <FormControlLabel
            value="oneTime"
            name="serviceType"
            control={<Radio />}
            onChange={onChangeRadio}
            label="Schedule One-Time (Service Order)"
            checked={serviceType === 'oneTime'}
            data-test-id="oneTime"
          />
          <Box ml={2}>
            {oneTime.map((s) => (
              <ServiceCheckbox
                key={s.id}
                service={s}
                onChange={onChange}
                disabled={oneTimeDisabled}
              />
            ))}
          </Box>
        </>
      )}
    </>
  )
}
